import {Suspense} from "react";
import {Helmet} from "react-helmet-async";
import {Navigate, useLocation} from "react-router";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {LoadingContainer} from "@/components/placeholder/LoadingContainer.tsx";
import {ErrorFallback} from "@/lib/handlers/ErrorFallback.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {isFreeTrialExpired} from "@/lib/userUtils.ts";
import {CreateEditCheck} from "@/pages/checks/update/CreateEditCheck.tsx";

export const CreateCheckPage = () => {
  const location = useLocation();
  const refetchQueries = location.state?.refetchQueries || [];

  const {user} = useCurrentUserContext();
  const freeTrialExpired = isFreeTrialExpired(user);
  if (freeTrialExpired) {
    return <Navigate to="/feature-unavailable" />;
  }

  return (
    <UpErrorBoundary
      fallback={
        <ContentContainer title={"Add New Check"}>
          <ErrorFallback />
        </ContentContainer>
      }
    >
      <Helmet>
        <title>Add New Check</title>
      </Helmet>
      <Suspense fallback={<LoadingContainer />}>
        <CreateEditCheck refetchQueries={refetchQueries} />
      </Suspense>
    </UpErrorBoundary>
  );
};
